export const DOMAIN_FILE_STORAGE = "FILE_STORAGE";
